import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-common-count-portlet',
  templateUrl: './common-count-portlet.component.html',
  styleUrls: ['./common-count-portlet.component.css']
})
export class CommonCountPortletComponent implements OnInit {

  constructor() { }

  @Input() className: any
  @Input() icon: any;
  @Input() titleOne: any
  @Input() titleTwo: any
  @Input() subContent: any
  @Input() heading: any
  @Input() meetingCount: any
  @Input() Obj:any

  // dashboardMeetingCounts: any =
  //   [{ "Type": 'Today', "MyMeeting": { "meetingCount": 1, "status": [{ "Scheduled": 1 }] }, "OtherMeetings": { "meetingCount": 1, "status": [{ "Scheduled": 1 }] } }, { "Type": 'This Month', "MyMeeting": { "meetingCount": 4, "status": [{ "Scheduled": 1, "Cancelled": 3 }] } }, { "Type": 'This Week', "MyMeeting": { "meetingCount": 6, "status": [{ "BehindSchedule": 1, "Scheduled": 5 }] }, "OtherMeetings": { "meetingCount": 4, "status": [{ "Scheduled": 3, "Completed": 1 }] } }]
  ngOnInit(): void {
    this.titleOne = this.Obj['MEETINGGROUP'];
    this.titleTwo = this.Obj['Type'];
  }

  createToolTip(array : any){
    let tooltip = '';
    array.map((x : any) => {
      let length = Object.keys(x).length
      Object.keys(x).map((item, indexes) => {
        tooltip += item +" : "+ x[item] + this.commaSeparator(indexes, length);
      })
    })
    return tooltip
  }

  commaSeparator(index : any, length : any){
    let comma = '';
    if((index + 1) == length){
      comma = '';
    }
    else{
      comma = ', ';
    }
    return comma;
  }

}
